export const pt = {
  headingLine1: "Vamos construir algo",
  headingAccent: "sólido",
  headingSuffix: " juntos.",
  paragraph:
    "Aberto para trabalhos freelance em back-end e IA. A forma mais rápida de me encontrar é pelo LinkedIn.",
  linkedinLabel: "LinkedIn",
};
